import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { AgGridReact } from '@ag-grid-community/react';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-alpine.css';
import Config from '../../../../../Utility/Config';
import { loaderStateTrue, loaderStateFalse, handleActiveLink, connectToWebsocket, disconnectToWebsocket } from '../../../../../Actions/AllAction';
import { ContactsList } from '../Controller/GroupController';
import { DebounceInput } from 'react-debounce-input';

function UserGroupComponent(props) {
    const [modules, setmodules] = useState([InfiniteRowModelModule]);
    const [gridparams, setgridparams] = useState(null);
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [defaultColDef, setdefaultColDef] = useState({
        flex: 1,
        //resizable: true,
        minWidth: 50

    });
    const [components, setcomponents] = useState({
        loadingRenderer: (params) => {
            if (params.value !== undefined) {
                return params.value;
            } else {
                return '<img src="https://www.ag-grid.com/example-assets/loading.gif">';
            }
        },
    }
    );

    const [contactsListData, setContactsListData] = useState([]);





    useEffect(() => {
        //console.log('contactsListData----------->', contactsListData)
    }, [contactsListData])
    //const [dataFor, setDataFor] = useState("add_contacts");

    // useEffect(() => {
    //     if (gridApi != null) {
    //         resetDataGrid();
    //     }
    //     // if (props.organizationFilterSelectedData == "" && gridApi != null) {
    //     //     gridparams.api.setDatasource([]);
    //     // }

    // }, [props.organizationFilterSelectedData,])

    useEffect(() => {
        if (props.uploadCSVModalFlag == false && gridApi != null) {
            resetDataGrid();
        }
    }, [props.uploadCSVModalFlag])


    useEffect(() => {
        if (props.searchValue.length > 1 && gridApi != null) {
            // console.log('searchValue.length > 1')
            resetDataGrid()
        }
        if (props.searchValue.length == 0 && gridApi != null) {
            // console.log('searchValue.length ==0')
            resetDataGrid()
        }
    }, [props.searchValue])


    const gridOptions = useMemo(
        () => ({
            infiniteInitialRowCount: 1,
            // onGridReady,
            paginationPageSize: 100,
            rowBuffer: 0,
            rowModelType: 'infinite',
            suppressCellSelection: true,
            suppressHorizontalScroll: true,

        }),
        []
    )

    const onGridReady = useCallback((params) => {
        //const onGridReady = (params) => {

        // console.log("entry onGridReady============")
        setgridparams(params)
        setGridApi(params.api)
        setGridColumnApi(params.columnApi)
        var datasource = serverSideDataSource()
        params.api.setDatasource(datasource);
    });

    // const onRowClicked = (event) => {
    //     const clickedData = event.data;
    //     console.log("clickedData======",clickedData)
    // }

    const serverSideDataSource = () => {
        return {
            getRows(params) {
                const { startRow, endRow, filterModel, sortModel } = params
                const { loaderStateTrue, loaderStateFalse } = props;
                loaderStateTrue();
                let filters = {};
                let filter_op = {};
                let globalQueryParamshash = {};
                // if (props.userCredentials?.user_details?.role_name == "app_admin") {
                //     if (props.organizationFilterSelectedData != "" && props.organizationFilterSelectedData.value != 'all') {
                //         globalQueryParamshash['org_id'] = props.organizationFilterSelectedData.value
                //     }
                // }

                if (props.tabsShow && props.dataFor == "add_contacts") {
                    //globalQueryParamshash["exclude"] = true;
                    globalQueryParamshash["group_id"] = props.getRowId;
                }
                //let newUrl = false;
                if (props.tabsShow && props.dataFor == "added_contacts") {
                    //globalQueryParamshash["exclude"] = false;
                    globalQueryParamshash["group_id"] = props.getRowId;
                    //newUrl = true
                }
                globalQueryParamshash["offset"] = startRow;
                globalQueryParamshash["limit"] = Config.pageDataLimit;
                if (props.searchValue != "") {
                    globalQueryParamshash['search_attr'] = props.searchValue
                    filter_op = Object.assign(filter_op, { "search_attr": "substring" });
                }
                if (Object.keys(filter_op).length > 0) {
                    filters["filter_op"] = JSON.stringify(filter_op);
                }
                filters['filters'] = JSON.stringify(globalQueryParamshash)

                ContactsList(filters, props.dataFor).then((response) => {
                    loaderStateFalse();
                    if (response.success) {
                        setContactsListData(response.data);
                        params.successCallback(response.data, response.total);
                        checkIdExistsOrNot()
                    } else {
                        params.failCallback();
                        Utility.toastNotifications("Something went wrong !", "Error", "error")
                    }
                    loaderStateFalse();
                }).catch((error) => {
                    loaderStateFalse();
                });


            }
        };
    }

    const checkIdExistsOrNot = () => {
        if (props.contact_group_contact.length > 0) {
            let newSelectedIds = props.contact_group_contact.map(group => group.user_id).flat();
            // console.log("newSelectedIds=======", newSelectedIds)
            preSelectedContact(newSelectedIds)
        }
    }

    const preSelectedContact = (newSelectedIds) => {
        const gridApi = gridOptions.api;
        if (gridApi) {
            gridApi.forEachNode((node) => {
                if (newSelectedIds.includes(node.data.id)) {
                    node.setSelected(true);
                } else {
                    node.setSelected(false);
                }
            });
        }
    };

    const resetDataGrid = () => {
        // console.log("entry resetDataGrid============")
        //gridApi.refreshCells(gridparams);
        // gridApi.purgeServerSideCache(null)
        var datasource = serverSideDataSource()
        gridApi.setDatasource(datasource);
    }

    useEffect(() => {
        if (gridApi != null && props.dataFor != "") {
            resetDataGrid();
        }
    }, [props.dataFor])

    useEffect(() => {
        if (gridApi != null && props.addContactSuccess) {
            resetDataGrid();
        }
    }, [props.addContactSuccess])

    useEffect(() => {
        if (gridApi != null && props.removeContactSuccess) {
            resetDataGrid();
        }
    }, [props.removeContactSuccess])

    const [headerCheckboxChecked, setHeaderCheckboxChecked] = useState(false);


    // console.log("addContactSuccess child=======", props.addContactSuccess)
    // console.log("removeContactSuccess child=======", props.removeContactSuccess)
    return (
        <div className="gridcontainer questionAgGrid">
            <div className="customTabBox">
                {props.tabsShow ?
                    <>
                        <button onClick={(e) => props.showGridData("add_contacts")} className={props.dataFor == "add_contacts" ? "active tabClass" : "tabClass"}>All user</button>
                        <button onClick={(e) => props.showGridData("added_contacts")} className={props.dataFor == "added_contacts" ? "active tabClass" : "tabClass"}>Added user</button>
                    </>
                    : null}
                <div className="pageinnersearch">
                    <button type="button" className="btn btn-link search_btn_addon"><i className="fa fa-search"></i></button>
                    <DebounceInput
                        minLength={2}
                        debounceTimeout={500}
                        onChange={props.handleSearchBar}
                        placeholder="Search a user"
                        value={props.searchValue}
                    />
                    {props.searchValue != "" ?
                        < button type="button" className="btn btn-link dropclosebtn"
                            onClick={props.clearSearchValue}
                        >
                            <img src={require('../../../../../Utility/Public/images/dropcloseicon.png')} className="searchClearIcon" />
                        </button>
                        : null}
                </div>
            </div>
            <div className='grid_content_inner' style={{ position: 'relative' }}>



                <div className="ag-theme-alpine aggridview agprises templateGrid contact_group_contact_grid">
                    <AgGridReact
                        modules={modules}
                        // columnDefs={props.columnDefs}
                        columnDefs={props.columnDefs.map(colDef => ({
                            ...colDef,
                            cellClass: 'vertical_center'
                        }))}
                        defaultColDef={defaultColDef}
                        components={components}
                        rowSelection="multiple"
                        rowModelType="infinite"
                        onGridReady={onGridReady}
                        //rowHeight={62.5}
                        // rowHeight={props.contactGroupGrid ? 45 : 62.5}
                        rowHeight={props.contactGroupGrid ? 60 : 47}
                        headerHeight={47}
                        cacheBlockSize={Config.pageDataLimit}
                        gridOptions={gridOptions}
                        // onSelectionChanged={(e) => { props.onRowClicked(e, gridApi) }}
                        onRowSelected={(e) => { props.onRowClicked(e, gridApi) }}
                    />
                </div>
            </div>
        </div>
    )
}

UserGroupComponent.defaultProps = {
    onRowClicked: null,
    tabsShow: false,
    contactGroupGrid: false
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token
    };
}

export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse, })(withRouter(UserGroupComponent));
